// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"556":"0b630986","731":"b90d450e","1602":"0b630986","2950":"24ba97e2","5164":"0b630986","5438":"0b630986","8180":"0b630986","8594":"afc40225","9521":"bfb65419","9605":"afc40225"}[chunkId] + ".chunk.css";
};